import { AccountDetails } from 'clientServerShared/types/account';
import { AppProviders } from 'projects/legacyClient/src/appProviders';
import { FC } from 'react';
import { HealthSummaryCard } from '@embark/shared-components/src/healthSummaryCard/healthSummaryCard';
import ReactDOM from 'react-dom';
import { getPetNumFromQueryString } from 'projects/legacyClient/src/react/pet/getPetNumFromQueryString';
import { handleGraphQLError } from '@embark/shared-components/src/services/errors/handleGraphQLError';
import { useAppSelector } from 'projects/legacyClient/src/react/state/hooks';
import { useGetHealthSummaryCardDataQuery } from '@embark/shared-components/src/generated/graphql-client-types';

export function initHealthSummaryCard(): void {
  ReactDOM.render(
    <AppProviders>
      <HealthSummaryCardContainer />
    </AppProviders>,
    document.getElementById('health-summary-card')
  );
}

const HealthSummaryCardContainer: FC = () => {
  const petNum = getPetNumFromQueryString();
  const accountDetails: AccountDetails | undefined = useAppSelector((state) => state.accountDetails);

  const { data, error } = useGetHealthSummaryCardDataQuery({
    variables: {
      petNum: petNum,
    },
  });

  if (error) {
    handleGraphQLError(error);
    return <></>;
  }

  if (!data?.me || !data.me.petByPetNum) {
    return <></>;
  }

  return (
    <HealthSummaryCard
      dog={data.me.petByPetNum}
      isBreeder={accountDetails.user?.permissions.isBreeder}
      shouldShowCareResourcesBanner={true}
    />
  );
};
